export default [{
  path: 'service/:leftid/:parent_id',
  name: 'backend_service',
  component: () => import('@/views/backend/admin/order/service/list'),
  meta: {
    tpflag: 'backend',
    title: '服务列表',
  }
}, {
  path: 'servicenew/:leftid/:parent_id',
  name: 'backend_servicenew',
  component: () => import('@/views/backend/admin/order/service/new'),
  meta: {
    tpflag: 'backend',
    title: '服务列表-新增服务',
  }
}, {
  path: 'order/:leftid/:parent_id',
  name: 'backend_order',
  component: () => import('@/views/backend/admin/order/list'),
  meta: {
    tpflag: 'backend',
    title: '订单列表',
  }
}, {
  path: 'projecttransfer/:leftid/:parent_id',
  name: 'backend_projecttransfer',
  component: () => import('@/views/backend/admin/order/project/transfer/list'),
  meta: {
    tpflag: 'backend',
    title: '项目转让',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_order.js